window.addEventListener('load', function() {

    function stickyHeader() {
        // Get the header element
    // var header = document.querySelector('header');
    // // on scroll event add class sticky to header
    // window.addEventListener('scroll', function() {
    //     if (window.scrollY > 40) {
    //         header.classList.add('sticky');
    //     } else {
    //         header.classList.remove('sticky');
    //     }
    // });

    // admin bar height
    var adminBarHeight = 0;
    if (document.querySelector('#wpadminbar')) {
        adminBarHeight = document.querySelector('#wpadminbar').offsetHeight;
    }

    // header height
    // var headerHeight = header.offsetHeight;
    // var bodyTopPadding = headerHeight + adminBarHeight;

    // add padding to body
    // header top  set to admin bar height
    document.querySelector('header').style.top = adminBarHeight + 'px';
}

stickyHeader();

window.addEventListener('resize', function() {
    stickyHeader();
}   );

});